export function getElement(shadowRoot, selector) {
    const element = shadowRoot.querySelector(selector);
    if (!element) {
        throw new Error("Failed to find element ${ selector } !");
    }
    return element;
}
